export const drawerWidth = 220;
export const headerHeight = 56;
export const navigationBarHeight = 64;
export const globalHeight = `calc(100dvh - 1rem)`;
export const globalMobileHeight = `calc(100dvh - ${headerHeight}px - ${navigationBarHeight}px - 1rem)`;
export const pageHeight = `calc(100% - ${headerHeight + 32}px)`;
